export default function (data) {
  let product = Object.assign({}, data)

  product.primaryPhoto = data.primary_photo[0].thumbnails.large.url

  product.features = [
    data.feature_1,
    data.feature_2,
    data.feature_3
  ]

  product.recommendations = [
    data.recommendation_1,
    data.recommendation_2,
    data.recommendation_3
  ]

  return product
}
